(() => {
  const storageKey = 'terjung-newsletter-submit';
  const fallbackText = 'Danke, deine Anmeldung ist eingegangen. Bitte bestätige die E-Mail in deinem Postfach. Falls du schon angemeldet bist, bist du bereits auf der Liste.';

  const initNewsletter = (root) => {
    if (!root || root.dataset.newsletterReady === 'true') return;

    const form = root.querySelector('form');
    const fields = root.querySelector('[data-newsletter-fields]');
    const email = root.querySelector('input[type="email"][name="contact[email]"]');
    const consent = root.querySelector('[data-newsletter-consent]');
    const submit = root.querySelector('[data-newsletter-submit]');
    const success = root.querySelector('[data-newsletter-success]');
    const consentError = root.querySelector('[data-newsletter-consent-error]');
    const serverError = root.querySelector('[data-newsletter-server-error]');
    const successText = root.dataset.newsletterSuccessMessage || '';

    root.dataset.newsletterReady = 'true';
    if (form) form.noValidate = true;

    const showSuccess = (text) => {
      if (!success) return;
      success.textContent = text || successText || fallbackText;
      success.hidden = false;
      if (fields) fields.hidden = true;
      window.sessionStorage.removeItem(storageKey);
    };

    const hasPostedSuccess = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    const cameFromSubmit = window.sessionStorage.getItem(storageKey) === '1';

    if (hasPostedSuccess) {
      showSuccess(successText || fallbackText);
    } else if (cameFromSubmit && !serverError) {
      showSuccess(fallbackText);
    }

    if (!form) return;

    if (consent && consentError) {
      consent.addEventListener('invalid', () => {
        consentError.hidden = false;
      });
      consent.addEventListener('change', () => {
        if (consent.checked) consentError.hidden = true;
      });
    }

    if (submit && consent && consentError) {
      submit.addEventListener('click', () => {
        if (!consent.checked) consentError.hidden = false;
      });
    }

    form.addEventListener('submit', (event) => {
      if (email && !email.checkValidity()) {
        event.preventDefault();
        if (consentError) {
          consentError.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
          consentError.hidden = false;
        }
        email.focus({ preventScroll: true });
        return;
      }

      if (consent && !consent.checked) {
        event.preventDefault();
        if (consentError) {
          consentError.textContent = 'Bitte bestätige kurz, dass du den Newsletter erhalten möchtest.';
          consentError.hidden = false;
        }
        consent.focus({ preventScroll: true });
        return;
      }

      if (consentError) consentError.hidden = true;
      window.sessionStorage.setItem(storageKey, '1');
      if (submit) {
        submit.dataset.originalText = submit.textContent.trim();
        submit.textContent = 'Wird angemeldet...';
        submit.setAttribute('aria-busy', 'true');
      }
    });
  };

  const initAll = (scope = document) => {
    const roots = scope.matches?.('[data-terjung-newsletter-signup]')
      ? [scope]
      : [...scope.querySelectorAll('[data-terjung-newsletter-signup]')];
    roots.forEach(initNewsletter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
